/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Topbar from './index';
import Section from './section';
import Items from './items';
import Item from './item';
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const LoggedInTopbar = ({ layoutId, path }) => {
	return (
		<Topbar>
            <div className='topbar__sales-details'>
                <Section>
                    <Items>
                        <Item className='active' label={<label><a href="//www.towersystems.com.au/how-can-we-help-you.html">SALES:</a> 1300 662 957 • NZ 0800 444 367</label>} />
                        <Icon name='FaEnvelope' type='fa' style={{ fontSize: 14 }} /> <Item className='disabled email sales' label='sales@towersystems.com.au' />
                        <Item className='active' label={<label><a href="//www.towersystems.com.au/help.html">SUPPORT:</a> +61 3 9524 8000</label>} />
                        <Icon name='FaEnvelope' type='fa' style={{ fontSize: 14 }} /> <Item className='disabled email' label='support@towersystems.com.au' />
                    </Items>
                </Section>
                <Section>
                    <Items>
                        <Icon name='BsUnlock' type='bs' style={{ fontSize: 14 }} /><Item className="logout" path="/logout" label='Logout' />
                        <Item path="//www.towersystems.com.au/help.html" label='Help' />
                        <Item path="//blog.towersystems.com.au" label='Blog' />
                    </Items>
                </Section>
            </div>

        </Topbar>
	);
};

export default LoggedInTopbar;
